export default __webpack_public_path__ + "static/media/instagram.2eb49614.png";